import { customerServiceLiveConversationsEntryPoint } from '@jira/spa-apps__customer-service-live-conversations/src/customerServiceLiveConversationsEntryPoint.entrypoint.tsx';
import { csmLiveConversationsRoute } from '@jira/router-routes__customer-service-live-conversations-routes/src/csmLiveConversationsRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { omniSubAccountStatus } from '@jira/router-resources__customer-service-common/src/omniSubAccountStatus.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { serviceDeskContextResource } from '@jira/router-resources__service-desk-context/src/serviceDeskContextResource.tsx';
import { featuresResource } from '@jira/router-resources__service-project-features/src/featuresResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const customerServiceLiveConversationsPageEntryPoint = createPageEntryPoint({
	main: customerServiceLiveConversationsEntryPoint,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
		isProjectsExpanded: true,
	},
});

export const csmLiveConversationsRouteEntry: Route = createEntry(csmLiveConversationsRoute, () => ({
	group: 'customer-service',
	perfMetricKey: 'customer-service.live-conversations',
	layout: globalLayout,

	navigation: {
		sidebarId: SidebarIdCsmApp,
	},

	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? customerServiceLiveConversationsPageEntryPoint
			: notFoundPageEntrypoint;
	},

	resources: [
		...getCustomerServiceL1NavigationResources(),
		serviceDeskContextResource,
		featuresResource,
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		omniSubAccountStatus,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
